/** @jsx jsx */
import { Styled, jsx, Container } from 'theme-ui'
import Layout from '../components/layout'
import Button from '../components/button'
import { Link } from 'gatsby'
import Helmet from 'react-helmet'
import YouTube from 'react-youtube'

export default ({
  data,
}) => {
  const videos = data.allYoutubeVideo.edges.map(edge => edge.node)

  const opts = {
    height: '500',
    width: '100%',
    playerVars: {
      // https://developers.google.com/youtube/player_parameters
      autoplay: 1,
    },
  }
  let id = null;
  videos.some((video) => {
    if (video.liveBroadcastContent === 'live' || video.liveBroadcastContent === 'upcoming') {
      id = video.originalID
      return true;
    }
  })

  return (
    <Layout>
      <Helmet>
        <title>Live</title>
        <style type="text/css">{`
          .youtubeContainer {
            width: 50%;
          }
        `}</style>
      </Helmet>
      <div>
        <Styled.h1
          sx={{
            mb: 5,
          }}>
            Live
        </Styled.h1>
        <div
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
          }}
        >
          <iframe src="/riot.html" width="50%" height="500"></iframe>
          <YouTube containerClassName='youtubeContainer' videoId={id} opts={opts}/>
        </div>
        <p>Join the conversation over on Riot</p>
        <Button as={Link} to='https://riot.commcon.xyz'>Join Riot</Button>
      </div>
    </Layout>
  )
}
